<script>

import Vue from 'vue';
import DefaultServerTable from '../../Libraries/ServerTable/DefaultServerTable';

export default {

    extends:DefaultServerTable,

    methods: {
        addCrmGroupFilters() {
            let groups = JSON.parse(this.crmGroups);

            groups.forEach((group) => {
                Vue.set(this.$refs.serverTable.filters, "crmgroup-" + group.uuid, {
                    name:"CRM Groep: " + group.name,
                    id:"crmgroup-" + group.uuid,
                    enabled:false,
                    onChange:() => {
                        this.$refs.serverTable.resetData();
                    },
                });
            });
        },

        addContactTypesFilter() {
            axios.defaults.validateStatus = function (status) {
                if (status >= 200 && status < 300) {
                    return true;
                }
                // Ignore 403 No Access errors.
                return status === 403;
            };
            axios.get(this.route('api.v1.settings.index'))
                .then((response) => {
                    response.data.projects.contacts.forEach((contactType) => {

                        Vue.set(this.$refs.serverTable.filters, `contact-type-${contactType.id}`, {
                            name: contactType.name,
                            id: `contact-type-${contactType.id}`,
                            enabled: false,
                            onChange: () => {
                                this.$refs.serverTable.resetData();
                            },
                        });
                    });
                });
        },
    },

    mounted() {
        this.addCrmGroupFilters();

        if (this.canFilterContactTypes) {
            this.addContactTypesFilter();
        }
    },

    props: {
        crmGroups: { required:true },
        canFilterContactTypes: {
            default: false,
        },
    },

}

</script>
